import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useGetHostsQuery, useUpdateHostMutation } from '../../api/peopleApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import EntityFormPage from '../../components/EntityFormPage/EntityFormPage';
import buttons from '../../styles/shared/buttons.module.css';

export default function HostEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const showToast = useToast();

  const { data: hosts, isLoading } = useGetHostsQuery();
  const host = hosts?.find((h) => h.id === id);
  const [updateHost, { isLoading: isSaving }] = useUpdateHostMutation();

  const { control, handleSubmit, reset } = useForm({
    defaultValues: { name: '', email: '' },
  });

  useEffect(() => {
    if (host) reset({ name: host.name, email: host.email });
  }, [host, reset]);

  const onSave = async (data) => {
    try {
      await updateHost({ id, name: data.name.trim(), email: data.email.trim() }).unwrap();
      showToast('success', 'Hosts', 'Host updated.');
      navigate('/manager/hosts');
    } catch (err) {
      showToast(
        'error',
        'Hosts',
        err?.status === 409 ? 'A host with that email already exists.' : errMsg(err, 'Could not save host.'),
      );
    }
  };

  if (isLoading) return <p className="textMuted">Loading…</p>;
  if (!host) return null;

  return (
    <EntityFormPage title="Edit host" backTo="/manager/hosts">
      <form onSubmit={handleSubmit(onSave)}>
        <Controller
          name="name"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Name</label>
              <InputText id={field.name} className="w-full mb-3" {...field} />
            </div>
          )}
        />
        <Controller
          name="email"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Email</label>
              <InputText id={field.name} type="email" className="w-full mb-3" {...field} />
            </div>
          )}
        />
        <Button type="submit" label="Save" className={buttons.saveBtn} loading={isSaving} />
      </form>
    </EntityFormPage>
  );
}
